export enum TrackingEventType {
  AREA_VIEW = 'AREA_VIEW',                              // When user opens an area
  AREA_ELEMENT_VIEW = 'AREA_ELEMENT_VIEW',              // When user views/focuses an area element
  AREA_ELEMENT_CLICK = 'AREA_ELEMENT_CLICK',            // When user clicks an area element
  FILE_DOWNLOAD = 'FILE_DOWNLOAD',                      // When user downloads a file
  FILE_VIEW = 'FILE_VIEW',                              // When user views a file (images, videos, etc.)
  FILE_SEARCH_PERFORMED = 'FILE_SEARCH_PERFORMED',      // When user searchs for files (media library ect..)
  FORM_SUBMISSION = 'FORM_SUBMISSION',                  // When user submits a form
  MEDIA_LIBRARY_OPEN = 'MEDIA_LIBRARY_OPEN',            // When user opens media library
  VIDEO_PLAY = 'VIDEO_PLAY',                            // When user plays a video
  VIDEO_PAUSE = 'VIDEO_PAUSE',                          // When user pauses a video
  VIDEO_SEEK = 'VIDEO_SEEK',                            // When user seeks through video
  VIDEO_DESTROY = 'VIDEO_DESTROY',                      // When video component is destroyed
  VIDEO_COMPLETE = 'VIDEO_COMPLETE',                    // When user completes watching a video
  WEBSITE_LINK_CLICK = 'WEBSITE_LINK_CLICK',            // When user clicks external website links
  AREA_NAVIGATION = 'AREA_NAVIGATION',                  // When user navigates between areas
  POPUP_OPEN = 'POPUP_OPEN',                            // When modals/popups are opened
  POPUP_CLOSE = 'POPUP_CLOSE',                          // When modals/popups are closed
  SESSION_START = 'SESSION_START',                      // When user is logged in
  CROSS_APP_TRACKING_EVENT = 'CROSS_APP_TRACKING_EVENT' // When a event is trigerred cross app
}
